<div class="card-container" id="cardContainer" [ngClass]="{'last-card-container': isLast}">
  <span id="labelName" class="link-name">{{labelName}}</span>
  <span id="iconSpan" class="icon-span" *ngIf="iconName && iconName!==''">
    <mat-icon id="iconName">{{iconName}}</mat-icon>
  </span>
</div>
